//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// autopilot-suggestion-nav imports
import { IState, IProps, IContainer } from "./AutopilotSuggestionsNav.d";
import * as s from "./AutopilotSuggestionsNav.styles";
// util
import { track, TrackingEvents } from "@util/analytics.util";
// state
import { IReduxState } from "@state/reducers/root.reducer";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import { IconButton } from "@material-ui/core";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateAfter from "@material-ui/icons/NavigateNext";

//////////////////
// COMPONENT
//////////////////
class AutopilotSuggestionsNavComponent extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private onPreviousClick = () => {
    const { currentIndex } = this.props;

    if (currentIndex === 0) {
      return;
    }

    this.onSuggestionIndexChange(currentIndex - 1);
    track(TrackingEvents.AUTOPILOT_SUGGESTIONS.AUTOPILOT_SUGGESTIONS_NAV_PREVIOUS_CLICKED);
  };

  private onNextClick = () => {
    const { currentIndex, suggestionsCount } = this.props;

    if (currentIndex === suggestionsCount - 1) {
      return;
    }

    this.onSuggestionIndexChange(currentIndex + 1);
    track(TrackingEvents.AUTOPILOT_SUGGESTIONS.AUTOPILOT_SUGGESTIONS_NAV_NEXT_CLICKED);
  };

  private onSpecificDotClicked = (index: number) => {
    this.onSuggestionIndexChange(index);
  };

  private onSuggestionIndexChange = (index: number) => {
    this.props.onSuggestionIndexChange(index);
    track(TrackingEvents.AUTOPILOT_SUGGESTIONS.AUTOPILOT_SUGGESTIONS_NAV_DOT_INDICATOR_CLICKED);
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderDots = () => {
    const { classes, suggestionsCount, currentIndex } = this.props;

    return (
      <div className={classes.dotContainer}>
        {[...Array(suggestionsCount)].map((_d, i) => {
          return (
            <div
              onClick={() => this.onSpecificDotClicked(i)}
              className={`${classes.dot} ${i === currentIndex ? classes.selected : ""}`}
              key={`suggestion-index-${i}`}
            ></div>
          );
        })}
      </div>
    );
  };

  public render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <IconButton onClick={this.onPreviousClick} classes={{ root: classes.iconButton }}>
          <NavigateBefore className={classes.leftArrow} />
        </IconButton>
        {this.renderDots()}
        <IconButton onClick={this.onNextClick} classes={{ root: classes.iconButton }}>
          <NavigateAfter className={classes.rightArrow} />
        </IconButton>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const reduxContainer = connect(mapStateToProps, {})(AutopilotSuggestionsNavComponent);

//////////////////
// WITH STYLES
//////////////////
export const AutopilotSuggestionsNav = withStyles(s.styles)(reduxContainer);
